import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { InsurancePackage } from '@lib/core/models/insurance-package.interface';
import { MEMBERS_API_URL } from '../tokens/api.tokens';

@Injectable({
  providedIn: 'root',
})
export class MembersApiService {
  private http = inject(HttpClient);
  private apiUrl = inject(MEMBERS_API_URL);

  getMemberPackageByUserId(userId: string): Observable<InsurancePackage> {
    return this.http.get<InsurancePackage>(`${this.apiUrl}/members/by-user/${userId}/package`);
  }

  getMemberPackageByMemberId(memberId: string): Observable<InsurancePackage> {
    return this.http.get<InsurancePackage>(`${this.apiUrl}/members/${memberId}/package`);
  }
}
